// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "../rel/stylesheet/" + {"534":"psdl-eherkenning-couple","544":"handsontable","659":"customer","801":"psdl-eherkenning-login","804":"flextool"}[chunkId] + "-core-min.css";
};